import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["currencyCode", "error", "inputUse", "numberDisplayHint", "onChange", "onBlur", "showCurrencySymbol", "value"];
import { UNFORMATTED } from 'customer-data-objects/property/NumberDisplayHint';
import { CurrencyInput } from 'foundations-components/transitional/components/CurrencyInput';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { NumberInput } from 'foundations-components/transitional/components/NumberInput';
import I18n from 'I18n';
import { getTransferableProps } from './filterInputProps';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { jsx as _jsx } from "react/jsx-runtime";
const FilterOperatorNumberInput = props => {
  const {
      currencyCode,
      error,
      inputUse,
      numberDisplayHint,
      onChange,
      onBlur,
      showCurrencySymbol,
      value
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const isError = error.get('error');
  const errorMessage = error.get('message');
  let Input;
  const transferableProps = getTransferableProps(rest);
  const {
    ['data-selenium-test']: dataSeleniumTest,
    placeholder
  } = transferableProps;
  // @ts-expect-error allows us to avoid spreading props to UIComponents
  const disabled = transferableProps.disabled;
  // @ts-expect-error allows us to avoid spreading props to UIComponents
  const readOnly = transferableProps.readOnly;
  if (showCurrencySymbol) {
    Input = /*#__PURE__*/_jsx(CurrencyInput, {
      "data-selenium-test": dataSeleniumTest,
      placeholder: placeholder,
      disabled: disabled,
      readOnly: readOnly,
      currency: currencyCode,
      onBlur: onBlur,
      onChange: onChange,
      use: inputUse,
      value: value
    });
  } else if (numberDisplayHint === UNFORMATTED) {
    Input = /*#__PURE__*/_jsx(TextInput, {
      "data-selenium-test": dataSeleniumTest,
      placeholder: placeholder,
      disabled: disabled,
      readOnly: readOnly,
      onBlur: onBlur,
      onChange: evt => {
        // @ts-expect-error Value does exist on target
        return onChange({
          target: {
            value: Number(evt.target.value)
          }
        });
      },
      type: "number",
      use: inputUse,
      value: `${value}`
    });
  } else {
    Input = /*#__PURE__*/_jsx(NumberInput, {
      "data-selenium-test": dataSeleniumTest,
      placeholder: placeholder,
      disabled: disabled,
      readOnly: readOnly,
      onBlur: onBlur,
      onChange: onChange,
      use: inputUse,
      value: value
    });
  }
  return /*#__PURE__*/_jsx(FormControl, {
    "aria-label": I18n.text('customerDataFiltersUI.customerDataFilters.FilterOperatorInput.ariaLabel'),
    error: isError,
    validationMessage: isError ? errorMessage : null,
    children: Input
  });
};
export default FilterOperatorNumberInput;